export default __webpack_public_path__ + "static/media/mini-logo.f2647c59.png";